import { StatisticalAnalysisViewDetailChartTypeChartsFactoryBar } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts-factory/statistical-analysis-view-detail-chart-type-charts-factory-charts/statistical-analysis-view-detail-chart-type-charts-factory-bar-chart.model'
import { StatisticalAnalysisViewDetailChartTypeChartsFactoryBarRadial } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts-factory/statistical-analysis-view-detail-chart-type-charts-factory-charts/statistical-analysis-view-detail-chart-type-charts-factory-bar-radial-chart.model'
import { StatisticalAnalysisViewDetailChartTypeChartsFactoryBarStacked } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts-factory/statistical-analysis-view-detail-chart-type-charts-factory-charts/statistical-analysis-view-detail-chart-type-charts-factory-bar-stacked-chart.model'
import { StatisticalAnalysisViewDetailChartTypeChartsFactoryColumn } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts-factory/statistical-analysis-view-detail-chart-type-charts-factory-charts/statistical-analysis-view-detail-chart-type-charts-factory-column-chart.model'
import { StatisticalAnalysisViewDetailChartTypeChartsFactoryColumnStacked } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts-factory/statistical-analysis-view-detail-chart-type-charts-factory-charts/statistical-analysis-view-detail-chart-type-charts-factory-column-stacked-chart.model'
import { StatisticalAnalysisViewDetailChartTypeChartsTypes } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts.model'
import { Options, XAxisOptions, YAxisOptions } from 'highcharts'

export class StatisticalAnalysisViewDetailChartTypeChartsFactory {
    static getTypeChart(type: StatisticalAnalysisViewDetailChartTypeChartsTypes, chartOptions: Options): Options {
        const xAxis: XAxisOptions = chartOptions?.xAxis as XAxisOptions
        const yAxis: YAxisOptions = chartOptions?.yAxis as YAxisOptions
        const categories = xAxis?.categories
        const series = chartOptions?.series
        const titleYAxis = yAxis?.title?.text
        switch (type) {
        case StatisticalAnalysisViewDetailChartTypeChartsTypes.STACKED_COLUMNS:
            return {
                ...StatisticalAnalysisViewDetailChartTypeChartsFactoryColumnStacked,
                xAxis: {
                    ...StatisticalAnalysisViewDetailChartTypeChartsFactoryColumnStacked.xAxis,
                    categories
                },
                yAxis: {
                    title: {
                        text: titleYAxis
                    }
                },
                series
            }
        case StatisticalAnalysisViewDetailChartTypeChartsTypes.BARS:
            return {
                ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBar,
                xAxis: {
                    ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBar.xAxis,
                    categories
                },
                yAxis: {
                    title: {
                        text: titleYAxis
                    }
                },
                series
            }
        case StatisticalAnalysisViewDetailChartTypeChartsTypes.STACKED_BARS:
            return {
                ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBarStacked,
                xAxis: {
                    ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBarStacked.xAxis,
                    categories
                },
                yAxis: {
                    title: {
                        text: titleYAxis
                    }
                },
                series
            }
        case StatisticalAnalysisViewDetailChartTypeChartsTypes.RADIAL:
            return {
                ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBarRadial,
                xAxis: {
                    ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBarRadial.xAxis,
                    categories
                },
                yAxis: {
                    ...StatisticalAnalysisViewDetailChartTypeChartsFactoryBarRadial.yAxis,
                    title: {
                        ...(StatisticalAnalysisViewDetailChartTypeChartsFactoryBarRadial.yAxis as YAxisOptions)?.title,
                        text: titleYAxis
                    }
                },
                series
            }
        default:
            return {
                ...StatisticalAnalysisViewDetailChartTypeChartsFactoryColumn,
                xAxis: {
                    ...StatisticalAnalysisViewDetailChartTypeChartsFactoryColumn.xAxis,
                    categories
                },
                yAxis: {
                    title: {
                        text: titleYAxis
                    }
                },
                series
            }
        }
    }
}
